import React, {useEffect, useState} from "react";

import "./shareProfile.css";

import ShareIcon from "../../../../assets/icon/Share.svg";
import WhatsappIcon from "../../../../assets/icon/whatsapp.png";
import PlayspotsBanner from "../../../../assets/img/prediction_app_playspots_banner.png";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import SharePlayCoinsModal from "../../../../components/sharePlayCoinsModal/SharePlayCoinsModal";

import { ShareSocial } from "react-share-social";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";

import PlayCoins from "../../../../assets/img/playcoins.png";
import {getPlayCoins} from "../../../../services/MainApiDetails";
import {useSelector} from "react-redux";
import { WHATSAPP, WHITE } from "../../../../utilities/colors";
import { WEB_URL } from "../../../../utilities/urls";

const style = {
  copyContainer: {
    display:"none"
  },
};

const PLAYSPOTS_BOOK_URL = "https://app.playspots.in";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ShareProfile = (prop) => {

  const [open, setOpen] = useState(false);

  const [message, setMessage] = useState(prop.scoreProfile && prop.scoreProfile.score != undefined && prop.type==0 ?"Hi, I am inviting you to play Playspots FIFA World Cup 2026 Prediction Contest and win iPhone 17. " +
      "\n I scored "+prop.scoreProfile.score +" points! Think you can beat me? " +
      "\n Predict & Win Daily!" +
      "Join now: "+WEB_URL:"Hi, I am inviting you to play Playspots FIFA World Cup 2026 prediction contest and win iPhone 17 \n\n Join now: "+WEB_URL);
  const [openAfter, setOpenAfter] = useState(false);
  const [divblock, setDivblock] = useState();
  const userProfile = useSelector((state) => state.userData.items);
  const shareUrl = `https://api.whatsapp.com/send`;
  useEffect(()=>{
    setDivblock(document.getElementsByClassName(".divblock").innerHTML)

  },[])
  useEffect(()=>{

    setMessage(prop.scoreProfile && prop.scoreProfile.score != undefined && prop.type==0  ?"Hi, I am inviting you to play Playspots FIFA World Cup 2026 Prediction Contest and win iPhone 17. " +
        "\nI scored "+prop.scoreProfile.score +" points! Think you can beat me? " +
        "\nPredict & Win Daily! " +
        "Join now: "+WEB_URL:"Hi, I am inviting you to play Playspots - FIFA World Cup 2026 prediction contest and win iPhone 17 \n\n Join now: "+WEB_URL)
  },[prop])
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClickOpenAfter = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseAfter = () => {
    setOpen(false);
  };
  function  sharePlayCoins()
  {
    getPlayCoins({}).then((res)=>{
      if (res.data.status)
      {
        if (prop.type == 1 ||prop.type == 2)
        {
          setOpenAfter(true)
        }
      }
    })
     .catch((e)=>{
          console.log(e)
        })
  }
  function sharePlayspots()
  {
    const url="https://play.google.com/store/apps/details?id=app.playspots.lite&hl=en_IN"
    window.open(url, "_blank");
  }
  function shareOnWhatsapp() {
    const text = encodeURIComponent(
        "🏆 FIFA World Cup 2026 - PlaySpots Mega Prediction Contest 🎯\n\n" +
        "Think you can predict better than me? 🔥\n" +
        "Join the challenge now and prove it!\n\n" +
        "👉 Click here to play: "+ WEB_URL
    );

    const url = `https://wa.me/?text=${text}`;
    window.open(url, "_blank");
  }
  function openBookPlayspots() {
    window.open(PLAYSPOTS_BOOK_URL, "_blank");
  }
  return (
    <>
      {true ? (
        <div className="shareProfile" style={{cursor: "pointer"}}>
          <div className="shareProfile-banner" onClick={openBookPlayspots}>
            <img src={PlayspotsBanner} alt="Explore PlaySpots - Book. Play. Repeat." />
          </div>
        </div>
      ) : (
        <div className="shareProfile" style={{cursor: "pointer"}}>
          <div className="shareProfile-wrapper">
            <div onClick={shareOnWhatsapp} className="shareProfile-part1">
              <div className="share-img">
                <img src={WhatsappIcon} alt="" />
              </div>
              <div>
                <p>Challenge your friends</p>
              </div>
            </div>
            <div onClick={shareOnWhatsapp} className="shareProfile-part2">
              <div className="arrow-img">
                <ArrowForwardIosIcon />
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="sharePlayCoinsModal">
        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <div className="sharePlayCoinsModal-wrapper">
            <div className="sharePlayCoinsModal-header">
              <h2>Challenge your friends</h2>
            </div>
            <div className="sharePlayCoinsModal-content">
            </div>

            <div className="sharePlayCoinsModal-button-wrapper">
              <button
                  style={{
                    background: WHATSAPP,
                    color: WHITE,
                    border: "none",
                    padding: "10px 20px",
                    borderRadius: "5px",
                    cursor: "pointer",
                    textAlign: "center"
                  }}
                  onClick={() => {
                    shareOnWhatsapp();
                    sharePlayCoins();
                  }}
              >
                Share on WhatsApp
              </button>
            </div>
          </div>
        </Dialog>

        <Dialog
          open={openAfter}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleCloseAfter}
          aria-describedby="alert-dialog-slide-description"
        >
          <div className="sharePlayCoinsModal-wrapper">
            <div className="sharePlayCoinsModal-header">
              <h2>Hurray!</h2>
            </div>
            <div className="sharePlayCoinsModal-img">
              <img src={PlayCoins} alt="" />
            </div>
            <div className="sharePlayCoinsModal-content">
              <p>20 Playcoins have added to your Playspots wallet.</p>
            </div>

            <div className="sharePlayCoinsModal-button-wrapper">
              <Button onClick={()=>sharePlayspots()} className="sharePlayCoinsModal-login-btn">
                VIEW WALLET
              </Button>
            </div>
          </div>
        </Dialog>
      </div>
    </>
  );
};

export default ShareProfile;